import {AxiosError} from 'axios';
import {GET_ADMIN_PROFILE_QUERY_KEY} from 'web-library/constants/queryKeys';
import {GET_ADMIN_PROFILE_URL} from 'web-library/constants/apiUrls';
import {AdminProfileResponse} from 'web-library/models/AccountManagementConfiguration';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: AdminProfileResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  enabled: boolean;
}

export const useGetAdminProfile = ({onError, onSuccess, uuid, enabled}: Input) => {
  const getAdminProfile = async () => {
    const res = await axiosClient.get<AdminProfileResponse>(GET_ADMIN_PROFILE_URL(uuid));

    return res.data;
  };

  return useCustomQuery([GET_ADMIN_PROFILE_QUERY_KEY, uuid], getAdminProfile, {
    onSuccess,
    onError,
    enabled,
  });
};
